import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { ApiError } from './lib/api'
import { sessionKey } from './lib/session'

// Un 401 sur /api/* vide la session (RequireSession renvoie a la connexion).
// retry: false : rejouer consommerait le compteur de tentatives.
export function createCommonsQueryClient(): QueryClient {
  const handleExpiredSession = (error: unknown) => {
    if (error instanceof ApiError && error.status === 401 && error.path.startsWith('/api/')) {
      queryClient.setQueryData(sessionKey, null)
    }
  }

  const queryClient: QueryClient = new QueryClient({
    queryCache: new QueryCache({ onError: handleExpiredSession }),
    mutationCache: new MutationCache({ onError: handleExpiredSession }),
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  })

  return queryClient
}
